// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c204bfc1","667":"7347820d"}[chunkId] + ".chunk.js";
};